import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import OtpInput from "react-otp-input";
import { useTranslation } from "react-i18next";
import { useLanguage } from "src/hooks/UseLanguage";
import LanguageSwitcher from "src/components/common/LanguageSwitcher";
import { OTP_POST_VERIFY_NAVIGATION } from "src/routes/welcomeRoutes";
import { verifyOtp, resendOtp } from "../../services/AuthenticationAPIs";

const Otp: React.FC = () => {
  const { t } = useTranslation();
  useLanguage(); // Initialize RTL support
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const api_key = localStorage.getItem("api_key")?.trim();
  const user_id = localStorage.getItem("user_id");
  const tenant_id = localStorage.getItem("tenant_id");
  const email = localStorage.getItem("email");

  useEffect(() => {
    document.body.style.overflow = "hidden";
  }, []);

  const handleVerifyBtn = async () => {
    if (!otp || otp.length !== 6) {
      message.warning(t("otp.enterValidOtp"));
      return;
    }

    setLoading(true);
    try {
      const result = await verifyOtp({
        api_key,
        user_id,
        tenant_id,
        email,
        code: otp,
      });

      if (result.status) {
        message.success(result.message || t("otp.verificationSuccessful"));
        navigate(OTP_POST_VERIFY_NAVIGATION);
      } else {
        message.error(
          result.message || t("otp.verificationFailed")
        );
      }
    } catch {
      message.error(
        t("otp.networkErrorRetry")
      );
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      const result = await resendOtp(email, api_key);
      if (!result.status) {
        message.warning(
          result.message || t("otp.resendFailed")
        );
      }
    } catch {
      message.error(t("otp.networkErrorLater"));
    }
  };

  return (
    <div className="body noScroll" style={{ backgroundImage: "url(/images/DatatramSignup.png)" }}>
      <div className="logo-wrapper">
        <img src="/images/DpLogo.png" className="logo-design" alt="logo" />
        <LanguageSwitcher />
      </div>
      <div className="app">
        <form className="formdesign">
          <div className="items-center">
            <img src="/images/NewEmail.png" className="new-email" alt="NewEmail" />
            <h2 className="entercode">{t("otp.enterCode")}</h2>
            <p className="Otp-Detail">
              {t("otp.verificationEmailSent")}
            </p>

            <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={6}
              renderSeparator={<span style={{ color: "#38ABD2" }}>-</span>}
              renderInput={props => (
                <div className="otp-block-row">
                  <input {...props} className="otp-boxes" />
                </div>
              )}
            />

            <button
              className="mt-5 button-otp"
              id="verify-acc"
              onClick={handleVerifyBtn}
              type="button"
              disabled={loading}
            >
              {loading ? t("otp.verifying") : t("otp.verifyAccount")}
            </button>

            <p className="resend-email">
              {t("otp.didNotReceive")}&nbsp;
              <button
                className="resend-button"
                onClick={e => {
                  e.preventDefault();
                  handleResendOtp();
                }}
                type="button"
              >
                {t("otp.resend")}
              </button>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Otp;

